import {AccountComponent} from "./AccountComponent";

export class AccountLeaf extends AccountComponent{
  releaseType: number;
  participateRuralActivity: boolean;


}
